<template>
  <vue-js-modal
    v-if="startNode"
    :key="reload"
    id="agStartNodeModal"
    class="agModal"
    name="agStartNodeModal"
    draggable=".card-header"
    width="75%"
    height="85%"
    :shiftX=".5"
    :shiftY=".25"
    :resizable="true"
    :clickToClose="false">
    <b-card>
      <template #header>
        <h4 v-if="disableUI || isLoading" class="agModal-title">View Start Node</h4>
        <h4 v-else class="agModal-title">Edit Start Node</h4>
      </template>
      
      <b-input-group size="md" prepend="Name">
        <b-input type="text" v-model="startNode.name" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
      </b-input-group>
      <b-input-group size="md" prepend="Description">
        <b-input type="text" v-model="startNode.description" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
      </b-input-group>
      <hr>
      <b-input-group id="agStartNodeModal-url" size="md" prepend="POST URL">
          <b-input type="text" v-model="url" ref="url" autocomplete="false" readonly></b-input>
          <b-button class="agStartNodeModal-copyButton agImageButton agInputGroup-append" :disabled="isLoading" @click="copyUrlButton_click"><fa icon="clipboard"/></b-button>
      </b-input-group>
      <b-input-group id="agStartNodeModal-body" size="md" prepend="POST BODY">
          <b-textarea 
            type="text" 
            v-model="body" 
            ref="body" 
            readonly
            no-resize
            :rows="5"
            :maxRows="15">
          </b-textarea>
          <b-button class="agStartNodeModal-copyButton agImageButton agInputGroup-append" :disabled="isLoading" @click="copyBodyButton_click"><fa icon="clipboard"/></b-button>
      </b-input-group>
      <div class="agInputGroup">
        <b-table
          :key="'mods-' + reloadMods"
          id="agStartNodeModal-modsTable"
          :fields="modHeaders"
          :items="startNode.mods"
          :thead-class="{'theadHidden': isLoadingMods }"
          borderless
          outlined
          small>
          <template #cell(parameter)="data">
            <b-input 
              type="text"
              v-model="data.item.param" 
              class="agStartNodeModal-param"
              autocomplete="false"
              :disabled="disableUI || isLoading" 
              @keyup="modParam_keyup">
            </b-input>
          </template>
          <template slot="=">
            <div class="agStartNodeModal-modEquals">=</div>
          </template>
          <template #cell(field)="data">
            <b-form-select 
              v-model="data.item.field"
              class="agStartNodeModal-field"
              :disabled="disableUI || isLoading"
              @change="modField_change(data.item.field, data.index)">
              <optgroup 
                  v-for="(group, key) in fields" 
                  :key="key"
                  :label="key">
                  <option 
                      v-for="(option, index) in group" 
                      :key="index"
                      :value="option.value">
                      {{option.text}}
                  </option>
              </optgroup>
            </b-form-select>
          </template>
        </b-table>
        <b-spinner v-if="isLoadingMods" id="agStartNodeModal-loadingModsSpinner"></b-spinner>
      </div>
      <hr>
      <div class="agInputGroup agInputGroupCentered">
        <label>Destination:</label>
        <b-input type="text" :value="destName" class="agInput agExtraSmallInput" disabled></b-input>
      </div>

      <template #footer>
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <div v-else-if="modalMessage">
          <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
        </div>
        <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <b-button
          class="agModal-buttonRight"
          variant="primary"
          :disabled="disableUI || isLoading"
          @click="saveButton_click"
          style="float:right;">
          Save
        </b-button>
      </template>
    </b-card> 

  </vue-js-modal>
</template>


<script>

// components
import InputSelect from "comp/ui/InputSelect";

// modules
import Vue from "vue";
import Server from "src/server";
import Util from "src/util/util";


export default {
    name: "ag-startNode-modal",
    components: {
      "ag-input-select": InputSelect
    },
    props:{
        node: Object,
        workflow: Object,
        disableUI: Boolean,
    },
    data(){
        return {
          startNode: null,
          reload: 0,
          reloadMods: 0,
          isLoading: false,
          isLoadingMods: false,
          modalMessage: "",
          modalMessageClass: "",
          url: "",
          body: "",
          modHeaders: ["parameter", "=", "field"],
          fields: {},
        };
    },
    computed: {

       name() {
          if(this.startNode.name)
          {
            return this.startNode.name;
          }
          return this.startNode.shortname;
        },

        destName() {
          if(this.startNode.dest)
            return this.startNode.dest.shortname;
          return "";
        },

    },

    watch: {
      
    }, 

    methods:{

      // UI Events
      cancelButton_click() {
        this.hide();
      },

      async saveButton_click() {
        // remove last, empty row
        this.startNode.mods.pop();

        var node = {
          object: this.startNode,
          type: "startNode"
        };
        this.isLoading = true;
        var result = await this.$store.dispatch("nodeStore/updateNode", {
          node: node
        });
        this.isLoading = false;
        if (result.data.success) {
          var updated = {
            type: "startNode",
            object: result.data.node
          };
          this.hide();
          this.$emit("updatedNode", updated);
        } 
        else {
          this.modalMessage = result.data.error;
          this.modalMessageClass = "agModal-errorMessage";
        }
      },

      modParam_keyup() {
        this.checkModRows();
        this.setBody();
      },

      modField_change(value, index) {
        var mod = this.startNode.mods[index];
        if (mod.field.field == "-- None --") {
          mod.field = null;
        } 
        this.checkModRows();
        this.setBody();
      },

      copyUrlButton_click() {
        this.$refs.url.select();
        document.execCommand("copy");
        this.modalMessage = "URL copied to clipboard";
        this.modalMessageClass = "agModal-successMessage";
      },

      copyBodyButton_click() {
        this.$refs.body.select();
        document.execCommand("copy");
        this.modalMessage = "Body copied to clipboard";
        this.modalMessageClass = "agModal-successMessage";
      },

      // other

      async show() {
        await this.setStartNode();
        await Vue.nextTick();
        await this.reset();
        this.$modal.show("agStartNodeModal");
      },

      hide() {
        this.$modal.hide('agStartNodeModal');
      },

      async reset() {
        this.modalMessage = "";
        this.modalMessageClass = "";
        this.errorField = "";
        this.setFields();
        this.setUrl();
        this.setBody();

        // if no mods or the last mod has a saved value add an empty row
        if(!this.startNode.mods)
          this.startNode.mods = [];
        this.checkModRows();
        this.reloadMods++;

      },

      async setStartNode() {
        if(this.node && this.node.type == "startNode") 
          this.startNode = this.workflow.startNode;
        else
          this.startNode = null;
      },

      async setUrl() {
        var url;
        try {
          var params = {
            workflow: this.workflow
          };
          var result = await Server.post("getWorkflowUrl", params).promise;
          if(!result.data.success)
            throw result.data.error;
          url = result.data.url;
        }
        catch(e) {
          console.log(`Failed 'getWorkflowUrl' server call. Error: ${e.toString()}`);
          url = "";
        }
        this.url = url;
      },

      async setBody() {
        var body = `{\n\tworkflow: "${this.workflow._id}",\n\tparams: {`;
        if(this.startNode.mods) {
          for(var i = 0; i < this.startNode.mods.length; i++) {
            var mod = this.startNode.mods[i];
            if(mod.param) { // exclude the blank row
              body += `\n\t\t${mod.param}: null`;
              if(i != this.startNode.mods.length - 1 && !this.isModEmpty(this.startNode.mods[i+1])) 
                body += ",";
            }
          }
        }
        body += "\n\t}\n}"
        this.body = body;
      },

      setFields() {
        this.fields = {
          " ": [{
              value: { object: "", field: "-- None --" },
              text: "-- None --"
        }]};
        var outputFields = Util.getOutputFields(this.$store, this.workflow);
        var optionGroups = Util.fieldsToOptionGroups(outputFields);
        Object.assign(this.fields, optionGroups);
      },

      // ensures there is one empty row at the end of the mod table
      checkModRows() {
        
        var modsToRemove = [];
        for(var i = 0; i < this.startNode.mods.length; i++) {
          var mod = this.startNode.mods[i];
          if(this.isModEmpty(mod))
            modsToRemove.push(mod);
        }
        this.startNode.mods = this.startNode.mods.filter(a => modsToRemove.indexOf(a) < 0);

        // add empty row as last mod
        var newMod = {
          param: "",
          field: {
            object: null,
            field: null,
            child: null
          }
        };
        this.startNode.mods.push(newMod);
      },

      isModEmpty(mod) {
        if(!mod.param && (!mod.field || (!mod.field.field && !mod.field.value)))
          return true;
        return false;
      },

    }
}
</script>


<style scoped lang="css">

.agStartNodeModal-copyButton {
  font-size: 24px;
}

#agStartNodeModal-body textarea {
  min-height: 110px;
}

#agStartNodeModal-modsTable {
  text-align: center;
  width: 1000px;
  margin: auto;
}

#agStartNodeModal-loadingModsSpinner {
  position: relative;
  left: 50%;
  margin-left: -20px;
}

.agStartNodeModal-param {
  width: 400px;
  display: inline-block;
}

.agStartNodeModal-modEquals {
  width: 200px;
  margin-top: 7.5px;
}

.agStartNodeModal-field {
  width: 400px;
  display: inline-block;
}

</style>


// WEBPACK FOOTER //
// src/components/nodes/StartNodeModal.vue